<template lang="html">
  <div
      style="width: 50px; height: 50px; position: relative; display: flex; flex-direction: column; justify-content: center;">
    <div
        style="color: var(--muted); font-size: 0.8em; width: 40px; height: 40px; margin: auto; z-index: 1; display: flex; flex-direction: column; justify-content: center; text-align: center;">
      {{ pourcentage }}%
    </div>
    <div
        style="position: absolute; width: 50px; height: 50px; border: double 2px transparent; border-radius: 100%;
            background-origin: border-box; background-clip: padding-box, border-box; margin:auto;"
        :style="'background-image: linear-gradient(white, white), conic-gradient(var(--primary) 0%, var(--primary) '+ pourcentage +'%, var(--separator) '+ pourcentage +'%, var(--separator) 100%);'">
    </div>

  </div>
</template>

<script>
export default {
  "name": "PourcentageStatTag",
  "components": {},
  "props": {
    pourcentage: Number
  }
}
</script>